import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const SideContact = ({ label, role, phone, desc, phones = [] }) => (
	<Stack>
		{label && <Typography variant="subtitle1">{label}</Typography>}

		{role && <Typography variant="body2">{role}</Typography>}

		{phone && (
			<Link component="button" underline="none" alignSelf="start">
				{phone}
			</Link>
		)}

		{desc && (
			<Typography variant="body2" color="secondary">
				{desc}
			</Typography>
		)}

		{Boolean(phones.length) &&
			phones.map(({ phone, type, id }) => (
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					key={id}
				>
					{phone && (
						<Link component="button" underline="none">
							{phone}
						</Link>
					)}
					{type && (
						<Typography variant="body2" color="secondary">
							{type}
						</Typography>
					)}
				</Stack>
			))}
	</Stack>
);

SideContact.propTypes = {
	label: PropTypes.string,
	role: PropTypes.string,
	phone: PropTypes.string,
	desc: PropTypes.string,
	phones: PropTypes.arrayOf(
		PropTypes.shape({
			phone: PropTypes.string,
			type: PropTypes.string,
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		}),
	),
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SideContact;
